export type ModelExperimentChatState = {
  switched?: boolean;
  feedback?: "up" | "down";
};

function storageKey(chatId: string) {
  return `model-experiment:${chatId}`;
}

export function loadModelExperimentChatState(
  chatId: string | null
): ModelExperimentChatState {
  if (!chatId) return {};
  try {
    const value = localStorage.getItem(storageKey(chatId));
    return value ? (JSON.parse(value) as ModelExperimentChatState) : {};
  } catch {
    return {};
  }
}

export function saveModelExperimentChatState(
  chatId: string | null,
  state: ModelExperimentChatState
) {
  if (!chatId) return;
  try {
    localStorage.setItem(storageKey(chatId), JSON.stringify(state));
  } catch {}
}
